
import { ChangeDetectionStrategy, ChangeDetectorRef, AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild, HostListener, OnDestroy, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

import { Constant } from 'src/app/constants/constant';
import { CartService } from 'src/app/services/cart.service';
import { CategoryService } from 'src/app/services/category.service';
import { CommonService } from 'src/app/services/common.service';
import { ConfigServiceService } from 'src/app/services/config-service.service';
import { ProductService } from 'src/app/services/product.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import { FormPopupComponent } from './form-popup/form-popup.component';
import { TextwithformPopupComponent } from './textwithform-popup/textwithform-popup.component';
import { AboutService } from 'src/app/services/about.service';
import { SwiperConfigInterface } from 'src/app/theme/swiper/swiper.module';
@Component({
  selector: 'calsoft-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  
  
})
export class LayoutComponent  implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  // support container scroll binding
  @ViewChild('searchResults', { static: false }) searchResultsRef: ElementRef;
  private searchResultsListener: any;
  private documentListener: any;
  private debugScroll: boolean = true; // set true temporarily to debug scroll bindings
  @Input() value: string;
  isLowEndMobile: boolean | any = false;
  @Input() homePageData: any;

  @Input() type: any=1;
  recentlyViewedProducts: Object;
  mobileLayout:any=false;

  @Input() pageNated: any = false;
  
  public serverPath = environment.commonImageApi + '/home/';

  public serverPath1 = environment.commonImageApi + '/commonSlider/';

  LogoSlider = {
    nav: false,
    dots: false,
    items: 1,
    margin: 20,
    loop: false,
    autoHeight: true,
    autoplay: true,
    
    responsive: {
        767: {
            items: 1
        },
        576: {
            items: 1
        },
        480: {
            items: 1
        },
        0: {
            items: 1
        }
    }
}

LogoSlider1 = {
  nav: false,
  dots: false,
  items: 1,
  margin: 20,
  loop: true,
  autoHeight: true,
  autoplay: true,
  
  responsive: {
      767: {
          items: 4
      },
      576: {
          items: 4
      },
      480: {
          items: 2
      },
      0: {
          items: 2
      }
  }
}

  featuredProducts: any;
  onSaleProducts: any;
  topRatedProducts: any;
  newArrivalsProducts: any;
  customField17:any;
  customField18:any;

  mediaGallery: any;
  sortParam: any = 'id' + ',' + Constant.Dsc;


  public youtubeUrl = environment.youtubeUrl;
  homePageProduct: any = [];

  public page: any = 0;
  public size: any = 3;
  lowEndMode: boolean = false;
  // initial larger load sizes (first page) to reduce subsequent pagination requests
  // increased to load more items on first render for better perceived performance
  public initialLoadSizeWeb: number = 12;
  public initialLoadSizeMob: number = 15;
  // prevent duplicate background prefetch
  private prefetchDone: boolean = false;
  private prefetchInProgress: boolean = false;
  private prefetchedItems: any[] = [];
  private scrollLocked: boolean = false;
  spinner: boolean = false;
  pageSize: any;
  slides: any = [];
  empty: any;
  layout: any;
  totalNumberOfElements: any;
  showCartIcon: any;
  showCartIncremented: any;
  showConfigurableDropdown: any;
  productImageWidth: any;
  productImageType: any;
  productImageWidthMob: any;
  productImageHeightMob: any;
  categoryArray: any=[];
  bannerHeight: any;
  bannerWidth: any;
  bannerMobWidth: any;
  bannerMobHeight: any;
  bannerTabletHeight:any;
  bannerTabletWeight:any;
  dataLoaed:any=false;
  fontFamily: string ; 
  height:any;
  width:any;
  gapBetweenImage:any;
  @Input() item: any;

  @Input() data: any;
  customField12:any;
  customField11:any;
  customField13:any=0;
  customField14:any;
  customField19:any;
  customField20:any=0;
  heightMob:any;
  widthMob:any;
  displayMobileImage:any;
  mobileGapBetweenImage:any;
  altImage:any;
  autoplay:any=0;
  homePageLayoutLoadedWeb: any;
  homePageLayoutLoadedMob: any;
  total: number;
  author: any;
  description: any;
  keywords: any;
  browserGraphImage: any;
  configData: any;
  stopScroll: boolean=false;
 isHomePage = false;

  constructor(

    private commonService: CommonService,
    private productService: ProductService,
    private aboutService: AboutService,
    private router: Router,
    private configService :ConfigServiceService,
    private cartServices:CartService,
    private userService:UserService,
    public sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private meta: Meta, 
    private title: Title,
    private cdr: ChangeDetectorRef,
    private zone: NgZone
  ) {
    this.checkScreenSize();

  }
  ngOnChanges(changes: SimpleChanges): void {
   
    
  }

  public brands = [];
  public banners = [];


  GapValue:any=70

  GapValue2:any=30
  mobileLayoutTwo: boolean = false;
  // Optional override to preload earlier; set from outside or keep undefined to use sensible defaults
  public scrollLoadThresholdOverride: number | undefined;
  // Buffer for a prefetched page and which page it is
  private prefetchedPage: number | null = null;
  checkDeviceType() {

    this.mobileLayoutTwo = window.innerWidth <= 768;
    const userAgent = navigator.userAgent || navigator.vendor;
    this.isLowEndMobile =
      this.mobileLayoutTwo &&
      (/Android.*Mobi/i.test(userAgent) || /iPhone/i.test(userAgent)) &&
      (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4);
  }

  /**
   * Compute how far (in pixels) from the bottom we should trigger a load.
   * Larger values cause earlier/preload behavior. You can override via
   * `scrollLoadThresholdOverride` if desired.
   */
  private getScrollThreshold(): number {
    if (typeof this.scrollLoadThresholdOverride === 'number') return this.scrollLoadThresholdOverride;
    // bump the thresholds slightly to preload earlier than before
    if (this.isLowEndMobile) return 1000; // mobile low-end: be more generous
    if (this.mobileLayoutTwo) return 700; // small screens
    return 500; // desktop
  }

  /**
   * A tighter threshold used for the actual immediate load (when user is very near the bottom).
   * We prefetch earlier using getScrollThreshold(), and load when remaining <= getLoadThreshold().
   */
  private getLoadThreshold(): number {
    return Math.max(200, Math.floor(this.getScrollThreshold() / 2));
  }

  /**
   * On mobile, if the user scrolls below the layout element we want to
   * trigger loading immediately (bypass prefetch-only behavior).
   */
  private shouldForceImmediateLoadOnMobile(): boolean {
    if (!this.isMobileView) return false;
    const el = this.searchResultsRef && this.searchResultsRef.nativeElement;
    if (!el) return false;
    try {
      const rect = el.getBoundingClientRect();
      // If the element's bottom is at or above the viewport bottom (plus small buffer),
      // the user has scrolled past it — trigger immediate load.
      return rect.bottom <= (window.innerHeight + 50);
    } catch (e) {
      return false;
    }
  }
 
  ngOnInit() {
this.homePageLayoutLoadedMob = +(localStorage.getItem('hplm') ?? '3');
this.homePageLayoutLoadedWeb = +(localStorage.getItem('hplw') ?? '5');

    // If we detect a low-end mobile device, mark it and reduce prefetch aggressiveness
    this.checkDeviceType();
    if (this.isLowEndMobile) {
      document.body.classList.add('low-end-device');
      // reduce initial sizes to avoid heavy DOM during startup
      this.initialLoadSizeMob = Math.max(1, Math.floor(this.initialLoadSizeMob / 2));
      this.initialLoadSizeWeb = Math.max(1, Math.floor(this.initialLoadSizeWeb / 2));
      // make prefetch thresholds larger so we prefetch earlier but do less work
      this.prefetchInProgress = false;
    }

     if(this.type==1){
            this.getHomePage();
         
          }else{
            this.homePageProduct =this.homePageData;

            if(this.pageNated){
              this.pageSize = this.homePageData[0]['pageSize']

              this.totalNumberOfElements = this.homePageData[0]['totalNumberOfElements'] - 1;
  
              this.total = this.homePageData[0]['totalElements'] - 1;
            }


          }
    this.checkDeviceType();
    const storedConfig = this.commonService.getConfigData();

    if (storedConfig) {
      this.configData = JSON.parse(storedConfig);
      if(this.configData!=null){
          this.getConfigData();
      }    

    } else {
      console.warn('No config data found in localStorage.');
    }

    // this.getConfigData();
   this.router.events.subscribe(() => {
      this.isHomePage = this.router.url === '/' || this.router.url === '/home';
    });

  }

  ngAfterViewInit(): void {
    // If the layout uses a scrollable container for results, attach a listener that reuses onScroll
    try {
      const el = this.searchResultsRef && this.searchResultsRef.nativeElement;
      if (el) {
        this.searchResultsListener = (ev: Event) => {
          // compute remaining scroll distance of container
          if (this.debugScroll) console.debug('container scroll listener fired', { time: Date.now() });
          const target = ev.target as HTMLElement;
          const scrollPos = target.scrollTop + target.clientHeight;
          const remaining = target.scrollHeight - scrollPos;
          const prefetchThreshold = this.getScrollThreshold();
          const loadThreshold = this.getLoadThreshold();
          const nextPage = this.page + 1;
          // Force immediate load on mobile if the element is scrolled past
          const forceLoad = this.shouldForceImmediateLoadOnMobile();
          if (remaining <= loadThreshold || forceLoad) {
            if (this.prefetchInProgress || this.spinner || this.stopScroll) return;
            if (this.scrollLocked) return;
            this.scrollLocked = true;
            try {
              this.zone.run(() => { this.onScroll(); });
            } finally {
              setTimeout(() => { this.scrollLocked = false; }, loadThreshold);
            }
          } else if (remaining <= prefetchThreshold) {
            if (!this.prefetchInProgress && !this.stopScroll && this.prefetchedPage !== nextPage) {
              try { this.zone.runOutsideAngular(() => { this.prefetchNextPage(this.size); }); } catch (e) { this.prefetchNextPage(this.size); }
            }
          }
        };
        el.addEventListener('scroll', this.searchResultsListener, { passive: true });
      } else {
        // If the element wasn't found (rare), attach a document-level listener as a fallback
        try {
          this.documentListener = (ev: Event) => {
            if (this.debugScroll) console.debug('document scroll fallback', { time: Date.now() });
            const scEl = document.scrollingElement || document.documentElement || document.body;
            const scrollPos = (scEl as HTMLElement).scrollTop + window.innerHeight;
            const remaining = (scEl as HTMLElement).scrollHeight - scrollPos;
            const prefetchThreshold = this.getScrollThreshold();
            const loadThreshold = this.getLoadThreshold();
            const nextPage = this.page + 1;
            const forceLoad = this.shouldForceImmediateLoadOnMobile();
            if (remaining <= loadThreshold || forceLoad) {
              if (this.prefetchInProgress || this.spinner || this.stopScroll) return;
              if (this.scrollLocked) return;
              this.scrollLocked = true;
              try { this.zone.run(() => { this.onScroll(); }); } finally { setTimeout(() => { this.scrollLocked = false; }, loadThreshold); }
            } else if (remaining <= prefetchThreshold) {
              if (!this.prefetchInProgress && !this.stopScroll && this.prefetchedPage !== nextPage) {
                try { this.zone.runOutsideAngular(() => { this.prefetchNextPage(this.size); }); } catch (e) { this.prefetchNextPage(this.size); }
              }
            }
          };
          document.addEventListener('scroll', this.documentListener, { passive: true });
        } catch (e) {
          // ignore
        }
      }
    } catch (e) {
      // non-critical
    }
  }

  ngOnDestroy(): void {
    try {
      const el = this.searchResultsRef && this.searchResultsRef.nativeElement;
      if (el && this.searchResultsListener) {
        el.removeEventListener('scroll', this.searchResultsListener);
      }
      if (this.documentListener) {
        try { document.removeEventListener('scroll', this.documentListener); } catch (e) {}
      }
    } catch (e) {
      // ignore
    }
  }

  @HostListener('document:scroll', [])
  onDocumentScroll(): void {
    if (this.debugScroll) console.debug('HostListener document:scroll fired');
    // fallback: reuse window logic
    try {
      const scEl = document.scrollingElement || document.documentElement || document.body;
      const scrollPos = (scEl as HTMLElement).scrollTop + window.innerHeight;
      const remaining = (scEl as HTMLElement).scrollHeight - scrollPos;
      const prefetchThreshold = this.getScrollThreshold();
      const loadThreshold = this.getLoadThreshold();
      const nextPage = this.page + 1;
      const forceLoad = this.shouldForceImmediateLoadOnMobile();
      if (remaining <= loadThreshold || forceLoad) {
        if (this.prefetchInProgress || this.spinner || this.stopScroll) return;
        if (this.scrollLocked) return;
        this.scrollLocked = true;
        try { this.zone.run(() => { this.onScroll(); }); } finally { setTimeout(() => { this.scrollLocked = false; }, loadThreshold); }
      } else if (remaining <= prefetchThreshold) {
        if (!this.prefetchInProgress && !this.stopScroll && this.prefetchedPage !== nextPage) {
          try { this.zone.runOutsideAngular(() => { this.prefetchNextPage(this.size); }); } catch (e) { this.prefetchNextPage(this.size); }
        }
      }
    } catch (e) {
      // ignore
    }
  }

  
  isMobileView: boolean = false;


  checkScreenSize() {
      this.isMobileView = window.innerWidth <= 768;  // Adjust this value based on your mobile breakpoint
      window.onresize = () => {
          this.isMobileView = window.innerWidth <= 768;
      };
  }

  TextwithFormPopup(data:any) {
    if (window.innerWidth > 768) {

       let dialogRef = this.dialog.open(TextwithformPopupComponent, {
          width: '850px',
          data: { item: data}
       });

       dialogRef.disableClose = true;
       dialogRef.afterClosed().subscribe(result => {

       });

    }
    else {
       let dialogRef = this.dialog.open(TextwithformPopupComponent, {
          minWidth: '100vw', height: '100vh',
          data: { item: data}
       });

       dialogRef.disableClose = true;
       dialogRef.afterClosed().subscribe(result => {

       });
    }

 }


  getSafeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  getHomePage() {
        

    let base: number;
    if (window.innerWidth > 768) {

      this.mobileLayout=false;
      this.size = this.homePageLayoutLoadedWeb==undefined?3: this.homePageLayoutLoadedWeb;
    } else {
      this.mobileLayout=true;
      this.size = this.homePageLayoutLoadedMob==undefined?5:this.homePageLayoutLoadedMob;
    }

    // respect low-end mode by reducing requested size
    if (this.lowEndMode) { this.size = Math.max(1, Math.floor((this.size || 3) / 2)); }

    this.productService.getHomePageProduct(this.page, this.size,this.value).subscribe(
      res => {

        this.empty = res['data']['empty']
        this.pageSize = res['data']['totalPages']

        this.totalNumberOfElements = res['data']['numberOfElements'] - 1;
        this.homePageProduct = res['data']['content'];

        // Warm a few image requests in low-priority time so subsequent navigation is faster
        try {
          this.prefetchImagesLowPriority(this.homePageProduct, 6);
        } catch (e) {
          // non-critical
        }

        if(this.homePageProduct.length<1){

          this.stopScroll=true;
        }

        this.total = res['data']['totalElements'] - 1;

       this.dataLoaed=true;

      // Prefetch the next page in background to improve perceived initial load (skip for low-end devices)
      try {
        this.prefetchNextPage(base || this.size);
      } catch (e) {
        // swallow prefetch errors; not critical
        console.warn('Prefetch failed', e);
      }
      
      // this.updateMetaTags();

      }
    )
  }

  /**
   * Prefetch up to `limit` images from the provided list using requestIdleCallback when available.
   * This is intentionally low-priority and non-blocking to avoid affecting TTI.
   */
  private prefetchImagesLowPriority(items: any[], limit: number = 6) {
    if (!items || !items.length) return;
    const images: string[] = [];
    for (let i = 0; i < items.length && images.length < limit; i++) {
      const it = items[i];
      // collect a few sensible image URLs from item (images array or customField)
      if (Array.isArray(it.images) && it.images.length) {
        const img = it.images[0]?.img || it.images[0];
        if (img) images.push(this.serverPath1 + img);
      } else if (it.customField6) {
        images.push(this.serverPath + it.customField6);
      }
    }

    const runner = () => {
      images.forEach(src => {
        try {
          const img = new Image();
          img.src = src;
        } catch (e) {
          // ignore
        }
      });
    };

    // Use requestIdleCallback if available to avoid jank; otherwise schedule a short timeout
    const ric = (window as any).requestIdleCallback;
    if (typeof ric === 'function') {
      ric(() => runner(), { timeout: 2000 });
    } else {
      setTimeout(runner, 1500);
    }
  }

  // Prefetch next page (page index 1) using the normal/base page size. Skips on low-end devices.
  private prefetchNextPage(baseSize: number) {

    const nextPage = this.page + 1;
    if (!this.stopScroll) {
      this.prefetchInProgress = true;
      this.productService.getHomePageProduct(nextPage, this.size, this.value).subscribe(
        (res: any) => {
          const products = res?.data?.content || [];
          if (products.length > 0) {
            // store prefetched items in a buffer and remember which page was prefetched
            this.prefetchedItems = products;
            this.prefetchedPage = nextPage;
            // do not append immediately; we'll append when the user nears the load threshold
          } else {
            this.stopScroll=true;
          }
          this.prefetchDone = true;
          this.prefetchInProgress = false;
        },
        (err) => {
          console.warn('Prefetch next page failed', err);
          this.prefetchDone = true;
          this.prefetchInProgress = false;
        }
      );
    }
  }

  public serverPath14 = environment.commonImageApi + "browerMediaImage/";

  updateMetaTags() {

    const imageUrl = this.serverPath14 + this.browserGraphImage;

    console.log(imageUrl);
    

    this.meta.updateTag({ property: 'og:image', content: this.browserGraphImage });
    this.meta.updateTag({ property: 'og:keywords', content: this.keywords });
    this.meta.updateTag({ property: 'og:title', content: this.author });
    this.meta.updateTag({ property: 'og:description', content: this.description });
    this.meta.updateTag({ property: 'og:url', content: Constant.REFERER });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
  }


  stripHtmlTags(value: string | undefined): string {
    return value ? value.replace(/<\/?[^>]+(>|$)/g, "") : "";
}
private hasMoreData = true;

onScroll() {

  if (this.debugScroll) console.debug('onScroll() invoked', { page: this.page, time: Date.now() });

  // If a background prefetch for the next page is running (usually immediately after initial load),
  // avoid triggering the onScroll fetch which can create duplicate items.
  if (this.prefetchInProgress && this.page === 0) {
    return;
  }

  if(this.stopScroll){
    return
  }

  this.spinner = true;

  // (Better: set size in ngOnInit or on resize)
    if (window.innerWidth > 768) {

      this.mobileLayout=false;
      this.size = this.homePageLayoutLoadedWeb==undefined?3: this.homePageLayoutLoadedWeb;
    } else {
      this.mobileLayout=true;
      this.size = this.homePageLayoutLoadedMob==undefined?5:this.homePageLayoutLoadedMob;
    }


  if (this.type === 1) {
    this.page++;
    // If we have a prefetched buffer for the next page, use it synchronously.
    if (this.prefetchedPage === this.page + 0 && this.prefetchedItems && this.prefetchedItems.length) {
      // consume buffer
      this.homePageProduct.push(...this.prefetchedItems);
      this.page = this.prefetchedPage!;
      this.prefetchedItems = [];
      this.prefetchedPage = null;
      try { this.cdr.detectChanges(); } catch (e) {}
      this.spinner = false;
      return;
    }

    this.productService.getHomePageProduct(this.page, this.size, this.value).subscribe(
      res => {
        const products = res['data'].content || [];

        if (products.length < 1) {
          console.warn("No products found.");
          this.spinner = false; // ✅ fix
          this.stopScroll=true;
          return;
        }

        
  this.homePageProduct.push(...products);
  try { this.cdr.detectChanges(); } catch (e) { /* ignore */ }

  this.spinner = false;
      },
      error => {
        console.error("Error loading products:", error);
        this.spinner = false;
      }
    );
  } else if (this.pageNated && this.type === 2) {
    this.page++;
    const value = this.homePageProduct[0]?.uuid;
    this.aboutService.getPageByUUid(value, this.page, this.size).subscribe(
      (res: any) => {
        const products = res || [];

        if (products.length < 1) {
          console.warn("No products found.");
          this.spinner = false; // ✅ fix
          this.stopScroll=true;
          return;
        }

       
  this.homePageProduct.push(...products);
  try { this.cdr.detectChanges(); } catch (e) { /* ignore */ }

  this.spinner = false;
      },
      error => {
        console.error("Error loading products:", error);
        this.spinner = false;
      }
    );
  } else {
    this.spinner = false;
  }
}

  /**
   * Window scroll listener fallback that reuses existing onScroll() logic.
   * Uses a lightweight locking/throttle to avoid duplicate concurrent loads.
   */
  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    if (this.debugScroll) console.debug('HostListener window:scroll fired', { time: Date.now() });
    const prefetchThreshold = this.getScrollThreshold();
    const loadThreshold = this.getLoadThreshold();
    const scrollPos = window.innerHeight + (window.scrollY || (window as any).pageYOffset || 0);
    const remaining = (document.documentElement?.scrollHeight || document.body.scrollHeight) - scrollPos;
    const nextPage = this.page + 1;

    if (remaining <= loadThreshold) {
      // avoid triggering while a fetch/prefetch is running, or while we already handled a recent event
      if (this.scrollLocked || this.prefetchInProgress || this.spinner || this.stopScroll) {
        return;
      }

      this.scrollLocked = true;
      try {
        // Reuse existing load logic
        this.zone.run(() => { this.onScroll(); });
      } finally {
        const delay = Math.max(300, Math.floor(loadThreshold / 2));
        setTimeout(() => { this.scrollLocked = false; }, delay);
      }
    } else if (remaining <= prefetchThreshold) {
      if (!this.prefetchInProgress && !this.stopScroll && this.prefetchedPage !== nextPage) {
        try { this.zone.runOutsideAngular(() => { this.prefetchNextPage(this.size); }); } catch (e) { this.prefetchNextPage(this.size); }
      }
    }
  }


  
  goToCategory(menu) {

    this.commonService.goToCategory(menu.title, menu.value);

  }
  goToCategories(id: any) {
    if(id>0){
      this.commonService.goToCategory(1, parseInt(id));
    }

  }

  dynamicFormPopup(formGroupId:any) {
    if (window.innerWidth > 768) {

       let dialogRef = this.dialog.open(FormPopupComponent, {
          width: '790px',
          data: { formId: formGroupId}
       });

       dialogRef.disableClose = true;
       dialogRef.afterClosed().subscribe(result => {

       });

    }
    else {
       let dialogRef = this.dialog.open(FormPopupComponent, {
          minWidth: '100vw', height: '100vh',
          data: { formId: formGroupId}
       });

       dialogRef.disableClose = true;
       dialogRef.afterClosed().subscribe(result => {

       });
    }

 }

  imageNavigation(id){


    if(id>0){
      this.commonService.goToCategory(1, parseInt(id));
    }

  }

  gotoCat(i, item) {


    if (i == 0 && item.customField4 > 0) {

      this.commonService.goToCategory(1, parseInt(item.customField4));
    } else if (i == 1 && item.customField6 > 0) {
      this.commonService.goToCategory(1, parseInt(item.customField6));
    } else if (i == 2 && item.customField7 > 0) {
      this.commonService.goToCategory(1, parseInt(item.customField7));
    } else if (i == 3 && item.customField8 > 0) {
      this.commonService.goToCategory(1, parseInt(item.customField8));
    }
  }

  productImageHeight:any;
  getConfigData() {


        let data = this.configData

          
          this.commonService.setCurrencyValue(data['currencyBase'])
          this.showCartIcon= data['showCartProductPage'];

          this.showCartIncremented=data['showCartIncremented'];

          this.showConfigurableDropdown=data['showConfigurableDropdownProductPage'];
          this.productImageHeight=data['productsImageHeight']
          this.productImageWidth=data['productsImageWidth']
          this.data=data;
          this.productImageType=data['productsImageType']
          this.productImageWidthMob=data['productsImageWidthMob']
          this.bannerHeight=data['bannerHeight'];
          this.bannerWidth=data['bannerWidth'];
          this.bannerMobWidth=data['bannerMobWidth'];
          this.bannerMobHeight=data['bannerMobHeight'];
          this.homePageLayoutLoadedMob=data['homePageLayoutLoadedMob'];
          this.homePageLayoutLoadedWeb=data['homePageLayoutLoadedWeb'];
          this.productImageHeightMob=data['productsImageHeightMob'];
          this.author=data['author'];
          this.description=data['description'];
          this.keywords=data['keywords'];
          this.browserGraphImage = data['browserGraphImage'];
          
         
         
          if(this.height !== undefined){
            this.height=this.item.height;
          }
      
          if(this.width !== undefined){
            this.width=this.item.width;
          }
      
          if(this.widthMob !== undefined){
            this.widthMob=this.item.widthMob;
          }
      
          if(this.heightMob !== undefined){
            this.heightMob=this.item.heightMob;
          }
      
          if(this.gapBetweenImage !== undefined){
            this.gapBetweenImage=this.item.gapBetweenImage;
          }
      
          if(this.mobileGapBetweenImage !== undefined){
            this.mobileGapBetweenImage=this.item.mobileGapBetweenImage;
          }
          
          if(this.displayMobileImage !== undefined){
            this.displayMobileImage=this.item.displayMobileImage;
          }
          
          let authourized = this.userService.getAuthenticatedUser();
          if (authourized) {
          this.cartServices.getCustomerCartProductCount()
          this.cartServices.geWishListProduct();
          }
}


link(url) {

  this.commonService.goToLink(url)
 
}

scroll(id) {

  this.commonService.scrollDown(id)
 
}

imagesToShow = 2; // Initial number of images to show
loadMoreStep = 2; // Number of images to load each time "Load More" is clicked

  onLoadMore() {
    this.imagesToShow += this.loadMoreStep;
  }


calculateFlexValue(item): string {
  if (item.layout === "2") {
    return '50';
  } else if (item.layout === "3") {
    return '33';
  } else if (item.layout === "4") {
    
    
    return `calc(25% - ${item.gapBetweenImage})`;
  } else {
    return '10';
  }
}

prependProtocol(url: string): string {
  if (!url.includes('http://') && !url.includes('https://')) {
    return 'https://' + url;
  }
  return url;
}

openInNewWindow(url: string) {
  if (url) {
    const fullURL = this.prependProtocol(url);
    this.commonService.goToLink(url)
  }
}
trackByFn(index: number, item: any): any {
  return item.position; // or return item.id; if you have a unique identifier
}

trackImgByFn(index: number, item: any): any {
  return item.images.valueId; // or return item.id; if you have a unique identifier
}


@ViewChild('image') image: TemplateRef<any>;
imageSrc:any;

popupDialog(path) {

  this.imageSrc=path;
  let dialogRef = this.dialog.open(this.image, {
    width: '350px',
    disableClose: true,
  });
  dialogRef.disableClose = true;

}


  playVideo() {
    const video = document.querySelector('video') as HTMLVideoElement;
    if (video) {
     // if (this.img.autoplay === 1 || this.img.autoplay === 2) {
        video.play();
     // }
    }
  }

active: string;
	scrollDown(value) {
		this.active = value;
		this.ScrollIntoView(this.active);
	}

	ScrollIntoView(elem: string) {
		this.active = "#" + elem;
		const ele = document.querySelector(this.active) as HTMLElement;
    console.log('Found element:', ele);
		if (ele) {
			const offsetTop = ele.getBoundingClientRect().top + window.pageYOffset;
			const paddingTop = 96;
			window.scrollTo({
				top: offsetTop - paddingTop,
				behavior: 'smooth'
			});
		} else {
			console.error('Element not found:', this.active);
		}
	}


}
